import { BaseService } from "../services/base.service";

const key = 'flaggers';

export interface FlaggerReducer {
  className: string;
  methodName: string;
  flaggerName: string;
}

export default function flagger(flaggerName: string): (
  target: object,
  propertyKey: string,
) => void {
  return (target: object, methodName: string): void => {
    let flaggers: FlaggerReducer[] = Reflect.getMetadata(key, BaseService) || [];
    flaggers.push({ className: target.constructor.name, methodName, flaggerName });
    Reflect.defineMetadata(key, flaggers, BaseService);
  };
}
